import React from 'react'
import {
  PIFormSection,
  PISectionInput,
  PISectionTitle,
  PISectionValidation,
} from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingsPageStyles'
import { GRID_CONFIG } from '../utils/patientFormConfig'

export const FormField = ({
  label,
  value,
  onChange,
  onKeyDown,
  type = 'text',
  placeholder,
  disabled = false,
  required = false,
  min,
  max,
  children,
  validationError,
  showValidation = true,
  gridConfig = GRID_CONFIG,
  style,
  inputStyle,
  className,
  inputClassName,
  ...inputProps
}) => {
  const hasError = validationError && showValidation
  const displayLabel = required && !label?.includes('*') ? `${label}*` : label

  const renderInput = () => {
    if (children) {
      return children
    }

    return (
      <PISectionInput
        type={type}
        value={value || ''}
        onChange={onChange}
        onKeyDown={onKeyDown}
        disabled={disabled}
        placeholder={placeholder}
        min={min}
        max={max}
        style={inputStyle}
        className={inputClassName}
        {...inputProps}
      />
    )
  }

  return (
    <PIFormSection size={gridConfig} style={style} className={className}>
      {label && <PISectionTitle>{displayLabel}</PISectionTitle>}
      <div className="d-flex flex-column w-100">
        {renderInput()}
        {hasError && <PISectionValidation>{validationError}</PISectionValidation>}
      </div>
    </PIFormSection>
  )
}

export const DisplayFormField = ({
  label,
  value,
  gridConfig = GRID_CONFIG,
  style,
  className,
}) => {
  return (
    <PIFormSection size={gridConfig} style={style} className={className}>
      {label && <PISectionTitle>{label}</PISectionTitle>}
      <div>{value}</div>
    </PIFormSection>
  )
}

export const CheckboxFormField = ({
  label,
  checked,
  onChange,
  disabled = false,
  children,
  gridConfig = GRID_CONFIG,
  style,
  className,
  checkboxProps = {},
}) => {
  return (
    <PIFormSection size={gridConfig} style={style} className={className}>
      <PISectionTitle
        className="d-flex gap-1 flex-row align-items-center"
        style={{ width: 'auto' }}
      >
        {label}
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          {...checkboxProps}
        />
      </PISectionTitle>
      {children}
    </PIFormSection>
  )
}

export const ArrayFormField = ({
  label,
  items = [],
  onAdd,
  onRemove,
  onUpdate,
  renderItem,
  addButtonText = 'Add',
  disabled = false,
  gridConfig = GRID_CONFIG,
  style,
  className,
  AddIcon,
}) => {
  return (
    <PIFormSection size={gridConfig} style={style} className={className}>
      <div className="d-flex flex-column">
        <PISectionTitle className="d-flex gap-1" style={{ width: 'auto' }}>
          {label}
          {AddIcon && (
            <AddIcon
              style={{ cursor: 'pointer' }}
              onClick={() => {
                if (!disabled && onAdd) {
                  onAdd()
                }
              }}
            />
          )}
        </PISectionTitle>
        {items.map((item, index) =>
          renderItem ? (
            renderItem(item, index, { onUpdate, onRemove, disabled })
          ) : (
            <div key={index} className="d-flex align-items-center gap-2 mb-2">
              <span>{item}</span>
              {onRemove && (
                <button
                  type="button"
                  onClick={() => !disabled && onRemove(index)}
                  disabled={disabled}
                  style={{ cursor: 'pointer' }}
                >
                  Remove
                </button>
              )}
            </div>
          )
        )}
      </div>
    </PIFormSection>
  )
}

export default FormField